module.exports = __webpack_public_path__ + "static/media/atcoder.fb263b01.png";